import {
  AHText,
  Box,
  useCircleSize,
  CreatedBySubject,
  StoreFormattedDate,
} from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { TodoListItemHeader_todo$key } from "./__generated__/TodoListItemHeader_todo.graphql";

import { TodoSubject } from "widgets/src/WidgetTodoOverview/TodoSubject/TodoSubject";
import { TodoListItemHeaderWrapper_todo$key } from "./__generated__/TodoListItemHeaderWrapper_todo.graphql";

export function TodoListItemHeader(props: {
  todo: TodoListItemHeader_todo$key;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoListItemHeader_todo on Todo {
        ...TodoListItemHeaderWrapper_todo
        subject {
          ...TodoSubject_TodoSubject
        }
        title
        isIssue

        createdByActor {
          ...CreatedBySubject_actor
        }
      }
    `,
    props.todo
  );

  const issuePlaceholder = todo.isIssue && todo.title === "";

  return (
    <TodoListItemHeaderWrapper todo={todo}>
      {todo.subject ? (
        <TodoSubject subject={todo.subject} highlightLast={issuePlaceholder} />
      ) : todo.createdByActor ? (
        <CreatedBySubject actor={todo.createdByActor} />
      ) : null}
    </TodoListItemHeaderWrapper>
  );
}

export function TodoListItemHeaderWrapper(props: {
  todo: TodoListItemHeaderWrapper_todo$key;
  children: React.ReactNode;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoListItemHeaderWrapper_todo on Todo {
        createdAtDate {
          ...StoreFormattedDate
        }
        timeToResolvedFormatted
      }
    `,
    props.todo
  );
  const size = useCircleSize("smallMedium");
  return (
    <Box spaceBottom="xsmall" spaceTop="small">
      <Box
        style={{
          flexDirection: "row",
          alignItems: "center",
          height: size,
        }}
      >
        <Box style={{ flex: 1 }}>{props.children}</Box>
        <AHText type="detail" color="washedText">
          {todo.timeToResolvedFormatted ?? (
            <StoreFormattedDate date={todo.createdAtDate} />
          )}
        </AHText>
      </Box>
    </Box>
  );
}
